module.exports = __webpack_public_path__ + "static/frost_giant_everlasting_one-b79a992e00b0e4a9dce0b1422ba15041.jpeg";